import { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import { toast } from 'react-toastify';

const TagsInput = ({
  labelText,
  name,
  placeHolderText,
  formProps,
  innerRef,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [value, setValue] = useState([]);

  const components = {
    DropdownIndicator: null,
  };

  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleChange = (e) => {
    setValue(e);
    formProps.setFieldValue(name, [...e]);
  };

  const handleInputChange = (e) => {
    setInputValue(e);
  };

  const handleKeyDown = (event) => {
    const isEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        if (isEmail(inputValue)) {
          const emailList =
            formProps.values[name].length > 0
              ? formProps.values[name].map((item) => item.value)
              : [];
          if (emailList.includes(inputValue)) {
            toast.error(`${inputValue} already exists`);
            return;
          }
          setInputValue('');
          setValue([...value, createOption(inputValue)]);
          formProps.setFieldValue(name, [...value, createOption(inputValue)]);
        } else {
          toast.error(`Enter a valid email address`);
          return;
        }
        event.preventDefault();
        break;
      default:
    }
  };

  return (
    <Form.Group controlId="react-select-tags-input">
      <Form.Label>
        {labelText}
        <br />
        <small>
          (Type email address and press <strong>Enter</strong>)
        </small>
      </Form.Label>
      <CreatableSelect
        ref={innerRef}
        components={components}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={handleChange}
        onInputChange={handleInputChange}
        onKeyDown={handleKeyDown}
        placeholder={placeHolderText}
        value={value}
        name={name}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: '#0649b5',
            neutral10: '#edf2f9',
            neutral20: '#d2ddec',
            neutral30: '#d2ddec',
            neutral50: '#b1c2da',
            neutral80: '#12263f',
            dangerLight: '#DEEBFF',
            danger: '#12263f',
          },
        })}
      />
    </Form.Group>
  );
};

TagsInput.propTypes = {
  name: PropTypes.string,
  labelText: PropTypes.string,
  placeHolderText: PropTypes.string,
  formProps: PropTypes.any,
  innerRef: PropTypes.any,
};

export default TagsInput;
